import { render, staticRenderFns } from "./zxDetil.vue?vue&type=template&id=17bdacc4&scoped=true"
import script from "./zxDetil.vue?vue&type=script&lang=js"
export * from "./zxDetil.vue?vue&type=script&lang=js"
import style0 from "./zxDetil.vue?vue&type=style&index=0&id=17bdacc4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17bdacc4",
  null
  
)

export default component.exports